import { createStore } from 'vuex'
import user from './modules/user'
import dict from './modules/dict'

const store = new createStore({
  modules: {
    user,
    dict,
  },
})

export default store
